import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';

const ImageContainer = styled.div`
  position: relative;
  overflow: hidden;
  background: #f5f5f5;
  transition: all 0.3s ease;
`;

const ImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  
  @keyframes loading {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

const OptimizedImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.3s ease;
  opacity: ${props => props.$loaded ? 1 : 0};
`;

const LazyImage = ({ 
  src, 
  alt, 
  className, 
  style,
  loading = "lazy",
  fetchpriority,
  width,
  height,
  ...props 
}) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const isEager = loading === "eager";
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
    skip: isEager,
  });

  const handleLoad = () => {
    setLoaded(true);
  };

  const handleError = () => {
    setError(true);
    setLoaded(true);
  };

  const shouldRender = isEager || inView;

  return (
    <ImageContainer ref={isEager ? undefined : ref} className={className} style={style}>
      {!loaded && !error && <ImagePlaceholder />}
      {shouldRender && (
        <OptimizedImage
          src={src}
          alt={alt}
          $loaded={loaded}
          loading={loading}
          fetchPriority={fetchpriority}
          width={width}
          height={height}
          onLoad={handleLoad}
          onError={handleError}
          {...props}
        />
      )}
    </ImageContainer>
  );
};

export default LazyImage;
